import { buttonStartLoadingState } from "../helpers";

export default function gravityForms() {
    // The theme no longer forces jQuery sitewide - Gravity Forms enqueues it
    // itself wherever a form renders, so on pages without a form there is no
    // jQuery and nothing to integrate with. Bail rather than throw: the
    // callables run unguarded, so a throw here would kill every callable
    // after this one and the landedHouses/loaded event.
    if (typeof jQuery === 'undefined') {
        return;
    }

    const $ = jQuery;

    $(document).on('click', '.gform_button', function () {
        buttonStartLoadingState($(this)[0]);
    });

    $(document).on('gform_post_render', function (event, form_id, current_page) {
        const form = document.querySelector(`#gform_wrapper_${form_id}`);

        if (!form) {
            return;
        }

        form.querySelectorAll('.gform_validation_errors').forEach((error) => {
            error.insertAdjacentHTML('afterbegin', '<h2 class="gform_submission_error_title">Error</h2>');
        });
    });
}
